<div class="_content bg-col-w z-2"
     [toggleClass]="'_searchOpen'"
     [toggleClassBy]="searchToggleId"
     #cmsNode>
    @if (content) {
    <div class="flex-column height-100 p-b">
        <!-- body -->
        <div class="_body flex-grow"
             [class.custom-scrollbar]="!client.isTouchy">
            <div #stage
                 [toggleClass]="'_hiddenStage'"
                 [toggleClassBy]="searchToggleId"
                 class="_stage _fadeInStage">
                <!-- menus -->
                <page-off-canvas-menu [component]="content"
                                      [level]="0" />
                <!-- bottom links -->
                @if(content.bottomLinks?.length) {
                <ul class="m-t p-l p-r">
                    @for (item of content.bottomLinks; track $index) {
                    <li class="m-t-1 b-a b-col-5 _bottom-link">
                        <href [hrefClass]="'p-l-2 p-r-2 bg-col-52 flex flex-middle flex-justify-between'"
                              [link]="item.link">
                            <span>
                                <p class="p1 col-1"
                                   *iCms="'text' of item">
                                </p>
                                <p class="c1 col-11 m-t-1"
                                   *iCms="'description' of item">
                                </p>
                            </span>
                            @if (item.icon) {
                            <i [ngClass]="item.icon"></i>
                            }
                        </href>
                    </li>
                    }
                </ul>
                }
                @if (content.promoTiles?.length) {
                <carousel class="block m-t p-l p-r"
                          [loop]="false"
                          [autoplay]="false"
                          [pagination]="false"
                          [spaceBetween]="16"
                          [slidesPerView]="1.33"
                          [navigation]="false"
                          [scrollbar]="false"
                          imageViewRoot>
                    @for (item of content.promoTiles; track $index) {
                    <ng-template carouselSlide>
                        <div class="b-a b-col-5 _promo-tile">
                            <href class="block"
                                  [link]="item.link">
                                <!-- named, not alt="": the title sits in a
                                     sibling block outside this link, so an
                                     empty alt would leave the link unnamed -->
                                <img class="w-12"
                                     [ratio]="1"
                                     [dfImage]="item.image"
                                     [alt]="item.title || ''">
                            </href>
                            <div class="bg-col-52 p-a-2">
                                <p *iCms="'title' of item"
                                   class="s1 col-1"></p>
                                <href *iCms="'description' of item"
                                      [link]="item.link"
                                      class="p2 col-11 m-t-2 block"></href>
                                @if(item.buttonCopy){
                                <href [link]="item.link">
                                    <span class="m-t-2 block"
                                          [buttonStyle]="'text-button'">
                                        <span *iCms="'buttonCopy' of item"></span>
                                    </span>
                                </href>
                                }
                            </div>
                        </div>
                    </ng-template>
                    }
                </carousel>
                }
            </div>
            <!-- search -->
            <div [toggleClass]="'!_hiddenStage'"
                 class="_fadeInStage"
                 [toggleClassBy]="searchToggleId">
                <div class="p-a flex flex-middle ">
                    <page-off-canvas-search-form class="flex-grow" />
                    <button class="m-l inline-flex flex-middle"
                            type="button"
                            (click)="close(true)"
                            aria-label="Close">
                        <i class="icon-close"></i>
                    </button>
                </div>
                <page-search-outlet class="p-b-8" />
            </div>
        </div>
    </div>
    }
</div>


<!-- overlay -->
<overlay class="z-1"
         (click)="close(true)"
         [visible]="overlayVisible$" />